import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-registered-product-details-dialog',
  templateUrl: './registered-product-details-dialog.component.html',
  styleUrls: ['./registered-product-details-dialog.component.scss']
})
export class RegisteredProductDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RegisteredProductDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
